import { Button } from 'components/Button';
import { useEmployees } from 'hooks/useEmployees';
import { useState } from 'react';
import { EmployeeService } from 'services';

import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Alert,
  AlertTitle,
  Box,
  CircularProgress,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  IconButtonProps,
  styled,
  Typography,
} from '@mui/material';

import { EmployeeDocument } from '../EmployeeDocument';

type IDialogForm = {
  title: string;
  isOpen: boolean;
  onClose: () => void;
};

interface ExpandMoreProps extends IconButtonProps {
  expand: boolean;
}

const ExpandMore = styled((props: ExpandMoreProps) => {
  const { expand, ...other } = props;
  return <IconButton size="small" {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(-90deg)' : 'rotate(0deg)',
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));

const bull = (
  <Box
    component="span"
    sx={{ display: 'inline-block', mx: '2px', transform: 'scale(0.8)' }}
  >
    •
  </Box>
);

export const DialogEmployeeImportDoc: React.FC<IDialogForm> = ({
  title,
  isOpen,
  onClose,
}) => {
  const {
    loadingCreate,
    handleSubmitWorksheet,
    fileRegisterEmployee,
    listErrors,
  } = useEmployees();

  const [expanded, setExpanded] = useState(true);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const onSubmit = (value: File | null | undefined) => {
    handleSubmitWorksheet(value);
  };

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>
        <Grid item textAlign="center" pt={1}>
          {title}
        </Grid>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <Divider />

      <DialogContent sx={{ pt: 1, pb: 0 }}>
        <Grid container spacing={2}>
          <Grid item>
            <Box p={2}>
              <Grid
                container
                alignItems="center"
                direction="column"
                spacing={3}
              >
                <Grid item>
                  <Typography align="center" lineHeight={2}>
                    <Typography fontWeight={500} align="center">
                      Por aqui você: <br />
                    </Typography>
                    {bull} Baixa o modelo de planilha padrão para cadastrar{' '}
                    <br />
                    colaboradores <br />
                    {bull} Envia a planilha padrão preenchida para o cadastrar{' '}
                    <br />
                    colaboradores
                  </Typography>
                  <Grid item textAlign="center" mt={2}>
                    <Button href={EmployeeService.getEmployeesWorksheet()}>
                      baixar arquivo padrão
                    </Button>
                  </Grid>
                </Grid>
              </Grid>

              <Divider sx={{ mt: 2, mb: 2 }} />

              <EmployeeDocument />

              {listErrors.length >= 1 && (
                <Box sx={{ width: '100%' }}>
                  <Alert
                    severity="error"
                    action={
                      <ExpandMore
                        expand={expanded}
                        onClick={handleExpandClick}
                        aria-expanded={expanded}
                        aria-label="show more"
                      >
                        <ExpandMoreIcon />
                      </ExpandMore>
                    }
                  >
                    <AlertTitle>
                      Não foi possível cadastrar os colaboradores.
                    </AlertTitle>
                    <Collapse in={expanded}>
                      <Typography variant="subtitle2" mb={1}>
                        Verifique os erros abaixo:
                      </Typography>

                      {listErrors.map((data, index) => {
                        return (
                          <li key={index}>
                            {data.message} (<strong>Linha {data.line}</strong>
                            ).
                          </li>
                        );
                      })}
                    </Collapse>
                  </Alert>
                </Box>
              )}
            </Box>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions sx={{ pt: 2, pb: 3 }}>
        <Grid container spacing={2} justifyContent="center">
          <Grid item>
            <Button variant="contained" onClick={onClose}>
              Cancelar
            </Button>
          </Grid>

          <Grid item>
            <Button
              type="submit"
              variant="contained"
              disabled={loadingCreate || !fileRegisterEmployee}
              onClick={() => onSubmit(fileRegisterEmployee)}
            >
              Enviar
              {loadingCreate && (
                <CircularProgress
                  size="small"
                  sx={{ width: 24, height: 24, ml: 2 }}
                />
              )}
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

